import { Text, TextProps } from '@rbilabs/universal-components';
import { DISABLE_STORE_CHANGE_DIALOG } from 'features/store/constants';
import { useIntl } from 'react-intl';

interface Props extends TextProps {}

export const StoreChangeDisclaimer = (props: Props) => {
  const { formatMessage } = useIntl();

  if (DISABLE_STORE_CHANGE_DIALOG) {
    return (
      <Text fontSize="xs" {...props}>
        {formatMessage({ id: 'changingYourStoreDisclaimer' })}
      </Text>
    );
  }
  return null;
};
